<template>
  <div class="wrapper" id="brand">
    <parallax class="page-header header-filter" :style="headerStyle">
      <div class="md-layout">
        <div class="md-layout-item">
          <div class="image-wrapper">
            <div class="brand">
              <h1>Los Kimonos</h1>
              <h3>神的孩子</h3>
            </div>
          </div>
        </div>
      </div>
    </parallax>
    <div class="main main-raised">
      <div class="section about-project" id="aboutProject">
        <div class="container">
          <about-project></about-project>
        </div>
      </div>
      <div class="section about-team" id="aboutTeam">
        <div class="container">
          <about-team></about-team>
        </div>
      </div>

      <div class="section documents" id="documents">
        <div class="container">
          <documents></documents>
        </div>
      </div>
      <div class="section contacts" id="contacts">
        <div class="container">
          <contacts></contacts>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import BasicElements from "./components/BasicElementsSection";

import AboutProject from "./components/AboutProject";
import Contacts from "./components/Contacts";
import Documents from "./components/Documents";
import AboutTeam from "./components/AboutTeam";

export default {
  components: {
    AboutProject,
    Contacts,
    Documents,
    AboutTeam
  },
  name: "index",
  bodyClass: "index-page",
  props: {
    image: {
      type: String,
      default: require("@/assets/img/fiitfuji.jpg")
    }
  },
  data() {
    return {
      firstname: null,
      email: null,
      password: null,
      leafShow: false
    };
  },
  methods: {},
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.image})`
      };
    }
  },
  mounted() {
    // console.log(this.image);
  }
};
</script>
<style lang="scss">
.section-download {
  .md-button + .md-button {
    margin-left: 5px;
  }
}

@media all and (min-width: 991px) {
  .btn-container {
    display: flex;
  }
}
</style>
